import { useQuery } from "@tanstack/react-query";
import { Tables } from "@/integrations/supabase/types";
import { getProfile } from "@/services/supabaseUsers";

export function useCurrentProfile(userId?: string | null) {
  return useQuery({
    queryKey: ["profile", userId],
    enabled: !!userId,
    queryFn: async () => {
      if (!userId) return null;
      const data = await getProfile(userId);
      return data as Tables<'profiles'> | null;
    },
    staleTime: 30 * 60 * 1000, // 30 minutes
    cacheTime: 60 * 60 * 1000, // 1 hour
    refetchOnWindowFocus: false,
    retry: 2,
  });
}
